import React, { FC, useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import moment from 'moment';

import { ClientInvitationSearchFilter, PublicUserProfileFragment } from 'api';
import { UseDateRange } from 'types/app';
import { DatePickers, PaddedPaper } from 'components';

import { ClearFiltersButton, RangePickerWrapper } from '../shared';
import Filters from './Filters';
import Chips from './Chips';

interface Props extends Partial<UseDateRange> {
  searchFilter: ClientInvitationSearchFilter;
  onSetSearchFilter: (searchFilter: ClientInvitationSearchFilter) => void;
}

const FilterBar: FC<Props> = ({ searchFilter, onSetSearchFilter, ...dateRangeOptions }) => {
  const { startDate, endDate, dateRange, setDateRange, setStartDate, setEndDate } =
    dateRangeOptions;
  const [cachedAddedByUsers, setCachedAddedByUsers] = useState([]);

  let nextStartDate: string = null;
  let nextEndDate: string = null;

  const hasUserFilters = !!(
    searchFilter.location_id__in.length +
    searchFilter.department_id__in.length +
    searchFilter.added_by_user_id__in.length
  );

  function handleSetStartDate(startDate: string) {
    nextStartDate = startDate;
    setStartDate(nextStartDate);
  }

  function handleSetEndDate(endDate: string) {
    nextEndDate = endDate;
    setEndDate(nextEndDate);

    onSetSearchFilter({
      ...searchFilter,
      created_at__gte: moment(nextStartDate).unix(),
      created_at__lt: moment(nextEndDate).add(1, 'days').unix(),
    });
  }

  function handleClearFilters() {
    onSetSearchFilter({
      ...searchFilter,
      department_id__in: [],
      location_id__in: [],
      added_by_user_id__in: [],
    });
  }

  function handleApplyFilter(
    nextFilter: ClientInvitationSearchFilter,
    selectedUsers: PublicUserProfileFragment[]
  ) {
    setCachedAddedByUsers(selectedUsers);
    onSetSearchFilter(nextFilter);
  }

  return (
    <PaddedPaper>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Grid container spacing={2}>
            <Grid item>
              <RangePickerWrapper>
                <DatePickers.Range
                  dateRange={dateRange}
                  startDate={startDate}
                  endDate={endDate}
                  onSetStart={handleSetStartDate}
                  onSetEnd={handleSetEndDate}
                  onSetRange={setDateRange}
                  includeToday
                />
              </RangePickerWrapper>
            </Grid>

            <Grid item>
              {/* Temporarily hide filter until we get these attributes populated at creation */}
              <Box display="none" height="100%">
                <Filters
                  filter={searchFilter}
                  selectedUsers={cachedAddedByUsers}
                  onSubmit={handleApplyFilter}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {hasUserFilters && (
          <Grid item>
            <ClearFiltersButton onClick={handleClearFilters} />
          </Grid>
        )}
      </Grid>
      <Chips
        searchFilter={searchFilter}
        onSetSearchFilter={onSetSearchFilter}
        addedByUsers={cachedAddedByUsers}
      />
    </PaddedPaper>
  );
};

export default FilterBar;
